var _path, _rect, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletDisconnect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 20.5H15.4946V21.5H19.5V20.5ZM20.5 19.5C20.5 20.0523 20.0523 20.5 19.5 20.5V21.5C20.6046 21.5 21.5 20.6046 21.5 19.5H20.5ZM20.5 2.5V19.5H21.5V2.5H20.5ZM19.5 1.5C20.0523 1.5 20.5 1.94771 20.5 2.5H21.5C21.5 1.39543 20.6046 0.5 19.5 0.5V1.5ZM15.4946 1.5H19.5V0.5H15.4946V1.5ZM15.4946 1.5C16.0469 1.5 16.4946 1.94772 16.4946 2.5H17.4946C17.4946 1.39543 16.5991 0.5 15.4946 0.5V1.5ZM16.4946 2.5V19.5H17.4946V2.5H16.4946ZM16.4946 19.5C16.4946 20.0523 16.0469 20.5 15.4946 20.5V21.5C16.5991 21.5 17.4946 20.6046 17.4946 19.5H16.4946Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.999512,
    y: 1,
    width: 15.9952,
    height: 20,
    rx: 1.5,
    stroke: "currentColor"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.6647,
    cy: 10.5452,
    rx: 1.66616,
    ry: 2.27272,
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletDisconnect);
export default __webpack_public_path__ + "static/media/wallet-disconnect.df6bc2837fba2a4d946c14024c551939.svg";
export { ForwardRef as ReactComponent };